import './ui.css';

export default function PostItem({ date, title, category, url }) {
  return (
    <a href={url} className="post-item" target="_blank" rel="noopener noreferrer">
      <span className="post-date">{date}</span>
      <span className="post-title">{title}</span>
      <span className="post-cat">{category}</span>
    </a>
  );
}
